/* global gtag, dataLayer, ym */

/**
 * useAnalyticsEventTracker
 * React hook
 *
 * Created by Vladimir Shishlyannikov on 22/11/2022.
 * Copyright (c) 2022 iWoo Ltd. All rights reserved.
 *
 */

import React from 'react';
// import ReactGA from 'react-ga';

/* Categories */
export const PARTNER_ACTION_CATEGORY = 'Partner Action';

/* Events */
export const EVENT_SIGNED_IN = 'SignedIn';
export const EVENT_SESSION_START = 'SessionStart';
export const EVENT_SESSION_STOP = 'SessionStop';
export const EVENT_DECLINE_SESSION = 'DeclineSession';

const useAnalyticsEventTracker = (category: string = PARTNER_ACTION_CATEGORY) => {
  const trackEvent = (category: string, label: string, action: string, value?: any, ...customFields: any[]) => {
    var event = Object.assign(
      {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        event: action,
      },
      value && { eventValue: value },
      ...customFields
    );

    // @ts-ignore
    dataLayer.push(event);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log(`Sent event: ${category}, parameters: ${JSON.stringify(event, null, 4)}`);
    }

    // Yandex.Metrika
    // if (action == EVENT_DISCIPLINE_SWITCH) {
    //     var goalParams = {
    //         discipline_name: label
    //     };

    //     window.ym && ym(55462138, 'reachGoal', action, goalParams);
    // }
  };

  const trackPageView = (category: string, label: string, action: string, value: any) => {
    // @ts-ignore
    dataLayer.push(
      Object.assign(
        {
          eventCategory: category,
          eventLabel: label,
          event: action,
        },
        value && { eventValue: value }
      )
    );
  };

  /**
   * Handles any member event
   * @param {string} action - a one of the MemberActionEvents values.
   */
  const onPartnerAction = (label: string, action: string) => {
    trackEvent(PARTNER_ACTION_CATEGORY, label, action);

    // // After adding Card Info
    // if (window.fbq && action === EVENT_REGISTER_PAYMENT_METHOD) {
    //     fbq('track', FB_EVENT_ADD_PAYMENT_INFO);

    //     // Yandex.Metrika
    //     var goalParams = {
    //         type: label,
    //     }

    //     window.ym && ym(55462138, 'reachGoal', EVENT_REGISTER_PAYMENT_METHOD, goalParams );
    // }
  };

  const onSignIn = (userId: string, url: string) => {
    // gtag('event', 'signed_in', {
    //     'event_category': PARTNER_ACTION_CATEGORY,
    //     'event_label': url,
    //     'user_id': userId
    // });
    // trackEvent(PARTNER_ACTION_CATEGORY, url, EVENT_SIGNED_IN, undefined, { userId, event: 'signedIn' });
  };

  // const eventTracker = (action = 'test action', label = 'test label') => {
  //   ReactGA.event({ category, action, label });
  // }

  return [trackEvent, trackPageView, onPartnerAction, onSignIn];
};

export default useAnalyticsEventTracker;
